import CurrencyFormat from '../components/CurrencyFormat'

export default ({ Vue }) => {
  Vue.component('CurrencyFormat', CurrencyFormat)
}
